import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { Store } from '@ngxs/store'
import { ConnectionBannerComponent, StageBarComponent } from '@saniup-webapps/shared/components'
import { CacheService } from './services/cache.service'
import { AppState, SetAuditId, SetEmbedded } from './state/app.state'

@Component({
  imports: [RouterModule, StageBarComponent, ConnectionBannerComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly store = inject(Store)
  private readonly activatedRoute = inject(ActivatedRoute)
  private readonly cacheService = inject(CacheService)

  readonly isEmbedded = this.store.selectSignal(AppState.isEmbedded)

  private readonly setEmbeddedState = this.activatedRoute.queryParamMap.pipe(takeUntilDestroyed()).subscribe((p) => {
    const embedded = p.get('embedded')?.toLowerCase() ?? undefined
    this.store.dispatch(new SetEmbedded(embedded === 'true'))
  })

  private readonly clearCache = this.activatedRoute.queryParamMap.pipe(takeUntilDestroyed()).subscribe((p) => {
    const clearCache = p.get('clearCache')?.toLowerCase() ?? undefined
    if (clearCache) {
      this.cacheService.evictCache$(clearCache).subscribe({
        next: () => window.alert('Cache wurde erfolgreich gelöscht, die Seite wird neu geladen.'),
        error: () => window.alert('Fehler beim Löschen des Caches, bitte versuche es später erneut.'),
        complete: () => {
          const url = new URL(window.location.href)
          url.searchParams.delete('clearCache')
          window.location.href = url.toString()
        },
      })
    }
  })

  private readonly setAuditId = this.activatedRoute.queryParamMap.pipe(takeUntilDestroyed()).subscribe((p) => {
    const auditId = p.get('auditId') ?? undefined
    this.store.dispatch(new SetAuditId(auditId))
  })
}
